import { useMemo } from "react";
import { matchPath, useLocation } from "react-router-dom";

export type RouteItem = {
    path: string;
    noLayout?: boolean;
    titleRightCol?: React.ReactNode | React.ComponentType;
    upperTitleMobile?: React.ReactNode | React.ComponentType;
};

export const useCustomElements = (routes: RouteItem[]) => {
    const location = useLocation();

    const { CurrentRightCol, CurrentUpperTitleMobile } = useMemo(() => {
        const pathname = location.pathname;

        const current =
            routes.find(
                (r) =>
                    !r.noLayout &&
                    !!matchPath({ path: r.path, end: true }, pathname)
            ) ??
            routes.find(
                (r) =>
                    !r.noLayout &&
                    !!matchPath({ path: r.path, end: false }, pathname)
            );

        return {
            CurrentRightCol: current?.titleRightCol ?? null,
            CurrentUpperTitleMobile: current?.upperTitleMobile ?? null,
        };
    }, [location.pathname, routes]);

    return { CurrentRightCol, CurrentUpperTitleMobile };
};
